import { jsxs, jsx } from 'react/jsx-runtime';
import '@websolutespa/bom-core';
import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { useState } from 'react';
import { Text } from '../../components/Text/text.js';

const StreamError = props => {
  const {
    item
  } = props;
  const label = useLabel();
  const [show, setShow] = useState(false);
  const shouldShowStreamError = true;
  return shouldShowStreamError ? jsxs("div", {
    className: "llm__stream-error llm__row",
    children: [jsxs("div", {
      className: "llm__stream-error__info llm__col --sm-10 --md-8 --lg-6",
      children: [jsx(Text, {
        body: label('llm.streamError')
      }), jsx("button", {
        className: "llm__stream-error__toggle",
        type: "button",
        onClick: () => setShow(!show),
        "aria-label": show ? label('llm.hideError') : label('llm.showError'),
        "aria-pressed": show,
        children: show ? label('llm.hideError') : label('llm.showError')
      })]
    }), show && jsx("code", {
      className: "llm__stream-error__error llm__hint",
      children: JSON.stringify(item.error)
    })]
  }) : undefined;
};

export { StreamError };
//# sourceMappingURL=StreamError.js.map
